export const SET_USER_PROFILE_IMG = "SET_USER_PROFILE_IMG";

export const setProfileImg = (image) => ({
  type: SET_USER_PROFILE_IMG,
  payload: image,
});
